"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsNumber_1 = __importDefault(require("../../typeAssertions/valueIsNumber"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const arrayFromObjectBuilder = ({ entryVars: { object, propName, }, processor, }) => {
    if (!(0, valueIsRecord_1.default)(object)) {
        processor.root.alert('Invalid object', `To create an array from an object, the input should be an object [${object}]`);
        return [];
    }
    if (!(0, valueIsNumber_1.default)(propName) && !(0, valueIsString_1.default)(propName)) {
        processor.root.alert('Invalid propName', 'The prop name should be a string or a number');
        return [];
    }
    return Object.entries(object).map(([, definition]) => {
        if (!(0, valueIsRecord_1.default)(definition)) {
            return undefined;
        }
        return definition[propName];
    });
};
exports.default = arrayFromObjectBuilder;
